import { Download, Plus, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProjectSectionHeader } from "@/components/projects";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "@/hooks/useAuth";
import { Permissions } from "@/lib/permissions";

interface BacklogHeaderProps {
  projectId: string;
  onCreateClick: () => void;
  onImportClick: () => void;
  onExportCsvClick: () => void;
  exportDisabled?: boolean;
}

export function BacklogHeader({ projectId, onCreateClick, onImportClick, onExportCsvClick, exportDisabled }: BacklogHeaderProps) {
  const { hasPermission } = useAuth(projectId);
  const canCreate = hasPermission(Permissions.Project.WorkItem.Create, projectId);

  return (
    <ProjectSectionHeader sectionName="Backlog">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex">
              <Button
                className="border-border-accent bg-toolbar"
                variant="outline"
                onClick={onExportCsvClick}
                disabled={exportDisabled}
                data-testid="backlog-export-all"
              >
                <Upload className="h-4 w-4" />
                Export CSV
              </Button>
            </span>
          </TooltipTrigger>
          {exportDisabled && (
            <TooltipContent>No work items to export</TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
      {canCreate && (
        <Button 
          variant="outline"
          onClick={onImportClick}
          data-testid="backlog-import-azure-devops"
          className="bg-toolbar border-border-accent"
        >
          <Download className="h-4 w-4" />
          Import from Azure DevOps
        </Button>
      )}
      {canCreate && (
        <Button onClick={onCreateClick}>
          <Plus className="h-4 w-4" />
          New Work Item
        </Button>
      )}
    </ProjectSectionHeader>
  );
}
